import { motion } from "framer-motion";
import { useEffect } from "react";
import { ToastContainer } from "react-toastify";
import Navbar from "../Navbar/Navbar";
const variants = {
  hidden: { opacity: 0, x: 0, y: 20 },
  enter: { opacity: 1, x: 0, y: 0 },
  exit: { opacity: 0, x: 0, y: 20 },
};

const sizes = {
  // 5.1: the homepage passes "full" - no max-width, the width it has always
  // rendered at. Previously it passed "8xl", which was not a key here, so the
  // lookup produced class="undefined".
  full: "",
  3: "max-w-3xl",
  4: "max-w-4xl",
  5: "max-w-5xl",
  6: "max-w-6xl",
  7: "max-w-7xl",
  8: "max-w-[100rem]",
};

const Layout = ({ children, title, size = 4 }) => {
  const width = sizes[size] ?? "";

  useEffect(() => {
    document.title =
      title !== "Home" ? title + " - SOFTEC'26" : "SOFTEC'26";
  }, [title]);

  useEffect(() => {
    if (title.includes("Home")) {
      document.body.classList.add("home");
    } else {
      document.body.classList.add("page");
    }

    return () => {
      if (title.includes("Home")) {
        document.body.classList.remove("home");
      } else {
        document.body.classList.remove("page");
      }
    };
  }, [title]);

  return (
    <>
      <a
        href="#main-content"
        className="focus:top-2 focus:left-2 focus:bg-white focus:text-logo-maroon-dark focus:px-4 focus:py-2 focus:rounded focus:shadow-lg sr-only focus:not-sr-only focus:fixed focus:z-[2000]"
      >
        Skip to main content
      </a>
      <Navbar />
      <ToastContainer />
      <div
        className={`${
          !title.includes("Home") ? "mt-[110px]" : ""
        } flex min-h-full items-center justify-center`}
      >
        <div className={`#page w-full ${width}`}>
          <motion.main
            id="main-content"
            initial="hidden"
            animate="enter"
            exit="exit"
            variants={variants}
            transition={{ duration: 0.45, type: "easeInOut" }}
            style={{ position: "relative" }}
          >
            {children}
          </motion.main>
        </div>
      </div>
    </>
  );
};

export default Layout;
